// German for the gate vocabulary: the 27 automatic condition labels, the manual defaults and
// the route labels. Imported by EngagementPage (condRoutes.ts itself stays free of React and
// the API layer — the exhaustiveness test imports it directly).
import { registerDe } from '../../i18n/index.js';

registerDe({
  // ── automatic conditions (mirror src/server/utils/gates.ts) ──
  'Client record exists': 'Kundendatensatz vorhanden',
  'Contact on file and named for this engagement': 'Kontakt erfasst und für diesen Auftrag benannt',
  'Qualification note recorded for this engagement': 'Qualifizierungsnotiz für diesen Auftrag festgehalten',
  'At least one document ingested and ready': 'Mindestens ein Dokument eingelesen und bereit',
  'Zero pending proposals': 'Keine ausstehenden Vorschläge',
  'Zero unresolved conflicts': 'Keine ungelösten Konflikte',
  'Every requirement confirmed': 'Jede Anforderung bestätigt',
  'Every MUST requirement maps to a deliverable': 'Jede Muss-Anforderung ist einem Arbeitsergebnis zugeordnet',
  'No deliverable without a requirement': 'Kein Arbeitsergebnis ohne Anforderung',
  'Estimate present': 'Schätzung vorhanden',
  'A SOW version is signed': 'Eine SOW-Version ist unterzeichnet',
  'Signature record captured on the signed version': 'Unterschriftsnachweis auf der unterzeichneten Version erfasst',
  'Baseline created': 'Baseline erstellt',
  'Kickoff date logged': 'Kickoff-Datum eingetragen',
  'Plan has milestones': 'Plan hat Meilensteine',
  'Client access provisioned': 'Kundenzugang eingerichtet',
  'All deliverables delivered': 'Alle Arbeitsergebnisse geliefert',
  'Every deliverable sits on an acceptance record': 'Jedes Arbeitsergebnis steht auf einem Abnahmeprotokoll',
  'At least one acceptance record issued': 'Mindestens ein Abnahmeprotokoll ausgestellt',
  'No open blocking or major defects': 'Keine offenen blockierenden oder schweren Mängel',
  'Acceptance record signed or deemed': 'Abnahmeprotokoll unterzeichnet oder stillschweigend abgenommen',
  'Signature record captured on an accepted record': 'Unterschriftsnachweis auf einem abgenommenen Protokoll erfasst',
  'All defects closed': 'Alle Mängel geschlossen',
  'No open questions outstanding': 'Keine offenen Fragen ausstehend',
  'No undecided change requests': 'Keine unentschiedenen Änderungsanträge',
  'No unsigned acceptance records': 'Keine nicht unterzeichneten Abnahmeprotokolle',
  'No open operator tasks': 'Keine offenen Operator-Aufgaben',

  // ── manual defaults (mirror DEFAULT_MANUAL_ITEMS) ──
  'Sponsor identified and reachable': 'Sponsor identifiziert und erreichbar',
  'Commercial model agreed in principle': 'Kommerzielles Modell grundsätzlich vereinbart',
  'Capacity available for the window': 'Kapazität für den Zeitraum verfügbar',
  'Discovery sessions complete': 'Discovery-Sitzungen abgeschlossen',
  'Register walkthrough held with the client': 'Register mit dem Kunden durchgegangen',
  'Estimate sanity-checked against capacity': 'Schätzung gegen die Kapazität plausibilisiert',
  'Delivery approach agreed internally': 'Vorgehen intern vereinbart',
  'Counter-signed copy filed': 'Gegengezeichnete Kopie abgelegt',
  'Payment terms and PO confirmed': 'Zahlungsbedingungen und Bestellung bestätigt',
  'Kickoff held with the client team': 'Kickoff mit dem Kundenteam durchgeführt',
  'Environments and access provisioned': 'Umgebungen und Zugänge eingerichtet',
  'Reporting cadence agreed': 'Berichtsrhythmus vereinbart',
  'Milestone demo delivered': 'Meilenstein-Demo gehalten',
  'Milestone invoice raised': 'Meilenstein-Rechnung gestellt',
  'UAT results reviewed with the sponsor': 'UAT-Ergebnisse mit dem Sponsor besprochen',
  'Residual minor defects agreed in writing': 'Verbleibende kleinere Mängel schriftlich vereinbart',
  'Runbook delivered': 'Betriebshandbuch geliefert',
  'Training / handover session logged': 'Schulung / Übergabesitzung festgehalten',
  'Hypercare window agreed': 'Hypercare-Zeitraum vereinbart',
  'Closure note written': 'Abschlussnotiz geschrieben',
  'Lessons learned captured': 'Lessons Learned festgehalten',
  'Final invoice raised': 'Schlussrechnung gestellt',

  // ── route labels (COND_ROUTE[*].label) ──
  'Client record': 'Kundendatensatz',
  'Name the sponsor on the engagement record': 'Sponsor im Auftragsdatensatz benennen',
  'Write the note on a G0 condition below': 'Die Notiz an einer G0-Bedingung unten schreiben',
  'Documents · not ready': 'Dokumente · nicht bereit',
  'Proposals · pending': 'Vorschläge · ausstehend',
  'Proposals · pending conflicts': 'Vorschläge · ausstehende Konflikte',
  'Register · status=draft': 'Register · status=draft',
  'Register · unfunded MUST': 'Register · nicht abgedeckte Muss-Anforderungen',
  'Register · deliverables': 'Register · Arbeitsergebnisse',
  'Contracting · plan': 'Vertrag · Plan',
  'Contracting · SOW': 'Vertrag · SOW',
  'Contracting · baselines': 'Vertrag · Baselines',
  'Set the kickoff date on the engagement record': 'Kickoff-Datum im Auftragsdatensatz setzen',
  'Client Portal · grants': 'Kundenportal · Freigaben',
  'Acceptance': 'Abnahme',
  'Acceptance · defects': 'Abnahme · Mängel',
  'Register · open questions': 'Register · offene Fragen',
  'Contracting · change requests': 'Vertrag · Änderungsanträge',
  'Dashboard · open tasks': 'Dashboard · offene Aufgaben',
}, 'condRoutes');
